// Utility functions for number formatting and string manipulation
import type { WellContribution } from "../types";

export function removeCommas(numberString: string): string {
  return numberString.replace(/,/g, "");
}

export function formatNumberWithThousandSeparator(
  number: number,
  decimalPlaces: number
): string {
  return number.toLocaleString("en-US", {
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces
  });
}

export interface FacilityTotals {
  sumGasRate: string;
  sumMonthlyGas: string;
}

export function calculateFacilityTotals(
  wellContributions: WellContribution[]
): FacilityTotals {
  const sumGasRate = formatNumberWithThousandSeparator(
    wellContributions.reduce(
      (sum, item) => sum + parseFloat(removeCommas(item.gasRate || "0")),
      0
    ),
    2
  );

  const sumMonthlyGas = formatNumberWithThousandSeparator(
    wellContributions.reduce(
      (sum, item) => sum + parseFloat(removeCommas(item.monthlyGasVolume || "0")),
      0
    ),
    2
  );

  return { sumGasRate, sumMonthlyGas };
}
